export const capabilitiesInfo = [
  {
    id: 'capability1',
    name: 'HTML/CSS',
    description:
      'HTML and CSS are two of the core technologies for building Web pages.',
  },
  {
    id: 'capability2',
    name: 'JavaScript',
    description:
      'Learn how to design and build websites that utilize Javascript.',
  },
  {
    id: 'capability3',
    name: 'React JS',
    description:
      'A JavaScript library for building user interfaces based on UI components.',
  },
  {
    id: 'capability4',
    name: 'Node JS',
    description:
      'The development platform for executing JavaScript code server-side',
  },
  {
    id: 'capability5',
    name: 'Angular JS',
    description:
      'AngularJS is what HTML would have been, had it been designed for applications.',
  },
  {
    id: 'capability6',
    name: 'Python',
    description:
      'Python is a general-purpose, object-oriented programming language with high-level programming capabilities.',
  },
  {
    id: 'capability7',
    name: 'Java',
    description:
      'Java is a multi-platform, object-oriented, and network-centric language.',
  },
];


export const learningPlanData = [
  {
    id: '1',
    learningPlan: 'Learning Plan Name',
    category: 'Category',
  },
  {
    id: '2',
    learningPlan: 'Learning Plan Name',
    category: 'Category',
  },
  {
    id: '3',
    learningPlan: 'Learning Plan Name',
    category: 'Category',
  },
  {
    id: '4',
    learningPlan: 'Learning Plan Name',
    category: 'Category',
  },
  {
    id: '5',
    learningPlan: 'Learning Plan Name',
    category: 'Category',
  },
  {
    id: '6',
    learningPlan: 'Learning Plan Name',
    category: 'Category',
  },
  {
    id: '7',
    learningPlan: 'Learning Plan Name',
    category: 'Category',
  },
  {
    id: '8',
    learningPlan: 'Learning Plan Name',
    category: 'Category',
  }
];